(function (root) {
  'use strict';
  const DAY = 86400000;
  const broad = /^(all|frontpage|our-selection|justarrived|bestselling|specialprices|sale|apple|brands|talabat)$/;
  const norm = value => String(value || '').normalize('NFKC').toLowerCase()
    .replace(/[\u202a-\u202e\u2066-\u2069]/g, '')
    .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/[إأآ]/g, 'ا').replace(/ى/g, 'ي')
    .replace(/ايفون|ايفوُن/g, 'iphone').replace(/ايباد/g, 'ipad')
    .replace(/برو/g, 'pro').replace(/ماكس/g, 'max').replace(/بلس/g, 'plus')
    .replace(/[-_/]/g, ' ').replace(/\s+/g, ' ').trim();
  const stop = new Set(['apple', 'with', 'for', 'and', 'the', 'from', 'black', 'white', 'blue', 'gray', 'grey', 'اسود', 'ابيض', 'ازرق', 'رمادي', 'من', 'مع', 'في', 'قطر', 'جهاز']);
  const words = value => [...new Set(norm(value).split(/[^\p{L}\p{N}]+/u).filter(v => v.length > 2 && !stop.has(v)))];
  const text = p => norm([p.title, p.type, p.handle, p.tags].join(' '));
  function kind(p) {
    const v = norm([p.title, p.type].join(' '));
    if (/sticker|استيكر|ملصق/.test(v)) return 'sticker';
    if (/gift card|itunes|ps card|بطاقة|بطاقات|تعبئة|roblox|steam card/.test(v)) return 'digital';
    if (/band|strap|سوار|اسوارة|سير الساعة/.test(v) && !/fitness tracker|جهاز.*تتبع|smart.*watch|ساعة.*ذكية/.test(v)) return 'band';
    if (/protector|screen guard|حماية|حمايه|حامي|زجاج/.test(v)) return 'protection';
    if (/case|cover|كفر|جراب/.test(v)) return 'case';
    if (/power bank|powerbank|باور بنك|شاحن.*متنقل|شاحن.*سعة|battery|بطارية/.test(v)) return 'powerbank';
    if (/cable|سلك|اسلاك|كيبل/.test(v)) return 'cable';
    if (/charger|charging|شاحن|شحن/.test(v)) return 'charger';
    if (/earbud|earphone|headphone|airpods|سماعة|سماعات/.test(v)) return 'audio';
    if (/wallet|stand|holder|grip|محفظة|ستاند|مسكة|قاعدة|حامل/.test(v)) return 'stand';
    if (/whoop|garmin|fitbit|smartwatch|smart watch|ساعة|جارمن/.test(v)) return 'wearable';
    if (/camera|microphone|tripod|ميكروفون|كاميرا|سيلفي|تصوير/.test(v)) return 'camera';
    if (/travel|luggage|سفر|حقائب|رحلات|تخييم/.test(v)) return 'travel';
    if (/kindle|ipad|tablet|ايباد|كيندل/.test(v)) return 'tablet';
    if (/iphone|smartphone|هاتف/.test(v)) return 'phone';
    if (/smart home|table|طاولة|منزل|اضاءة|ثلاجة|مكنسة|قفل/.test(v)) return 'home';
    return 'other';
  }
  function models(p) {
    const v = norm([p.title, p.type, p.handle].join(' '));
    return [...new Set((v.match(/iphone\s*(?:\d{1,2}\s*(?:pro\s*max|pro|plus|mini)?|air)/g) || []).map(norm))];
  }
  function whoop(p) {
    const groups = (p.groups || []).join(' ');
    if (/whoop-mg/.test(groups)) return 'mg';
    if (/whoop-5/.test(groups)) return '5';
    if (/whoop-4/.test(groups)) return '4';
    const v = text(p);
    if (!/whoop/.test(v)) return null;
    if (/\bmg\b/.test(v)) return 'mg';
    return v.match(/whoop\s*([45])(?:\b|\.0)/)?.[1] || null;
  }
  const complements = {
    phone: ['case', 'protection', 'charger', 'cable', 'powerbank', 'stand', 'audio'],
    case: ['protection', 'stand', 'powerbank', 'charger'],
    protection: ['case', 'charger', 'stand'],
    wearable: ['band', 'charger', 'audio'], band: ['band', 'charger'],
    tablet: ['case', 'protection', 'stand', 'charger', 'cable'],
    camera: ['camera', 'stand', 'cable', 'powerbank'],
    travel: ['travel', 'powerbank', 'charger', 'camera'],
    audio: ['case', 'charger', 'stand'],
    powerbank: ['cable', 'charger'], charger: ['cable', 'powerbank'],
    cable: ['charger', 'powerbank'], stand: ['case', 'charger', 'powerbank'],
    home: ['home'], digital: ['digital'], sticker: ['sticker']
  };
  function family(p) {
    return norm(p.title).replace(/\b(black|white|blue|green|red|pink|purple|silver|grey|gray|orange|yellow|gold|navy|beige|titanium)\b/g, '')
      .replace(/اسود|ابيض|ازرق|اخضر|احمر|وردي|بنفسجي|فضي|رمادي|ذهبي|كحلي|بيج/g, '')
      .replace(/\s+/g, ' ').trim();
  }
  function anchors(profile, now) {
    const views = (profile.views || []).slice(0, 20).filter(v => now - Number(v.at || 0) < 30 * DAY)
      .map(v => ({p: v, weight: 6 * Math.exp(-(now - v.at) / (7 * DAY))}));
    return [...(profile.cart || []).map(p => ({p, weight: 18})), ...views,
      ...(profile.purchased || []).slice(0, 24).map(p => ({p, weight: 4}))];
  }
  function compatible(p, active) {
    const k = kind(p);
    const pModels = models(p);
    const known = active.flatMap(a => models(a.p));
    if (known.length && ['case', 'protection'].includes(k) && pModels.length && !pModels.some(m => known.includes(m))) return false;
    const ownWhoop = whoop(p);
    const knownWhoop = active.map(a => whoop(a.p)).filter(Boolean);
    if (['band', 'charger'].includes(k) && ownWhoop && knownWhoop.length && !knownWhoop.includes(ownWhoop)) return false;
    const phones = known.map(m => Number(m.match(/iphone\s*(\d+)/)?.[1])).filter(Boolean);
    if (phones.length && phones.every(n => n >= 15) && ['charger', 'cable', 'powerbank'].includes(k) && /lightning|لايتنينق|لايتننج/.test(text(p)) && !/3\s*(?:in|في)\s*1/.test(text(p))) return false;
    return true;
  }
  function rank(products, profile, options) {
    profile = profile || {};
    options = options || {};
    const now = options.now || Date.now();
    const limit = Math.min(40, Math.max(1, options.limit || 36));
    const active = anchors(profile, now);
    const query = profile.query && now - Number(profile.query.at || 0) < DAY ? norm(profile.query.value) : '';
    const queryTerms = words(query);
    const queryKind = kind({title: query});
    const queryAnchor = query ? [{p: {title: query}, weight: 24}] : [];
    const explicit = queryAnchor.length && models(queryAnchor[0].p).length ? queryAnchor : active.filter(a => a.weight >= 10);
    const compatibilityAnchors = explicit.length ? explicit : active;
    const excluded = new Set([...(profile.cart || []), ...(profile.purchased || [])].map(p => String(p.id)));
    const unique = new Map();
    products.forEach((p, index) => {
      if (!p || !p.id || p.available === false || excluded.has(String(p.id)) || /(?:^|\s)no-recommendations(?:\s|$)/.test(p.tags || '') || !compatible(p, compatibilityAnchors)) return;
      const k = kind(p);
      let score = 10 - index * .015 + (p.sale ? 1 : 0);
      let relevant = false;
      const pTerms = words([p.title, p.type, p.tags].join(' '));
      if (query) {
        const hits = queryTerms.filter(t => pTerms.includes(t)).length;
        const exact = models({title: query}).some(m => models(p).includes(m));
        score += hits * 9 + (exact ? 65 : 0);
        if (k === queryKind && queryKind !== 'other') score += 30;
        if (exact || hits >= Math.min(2, queryTerms.length) && hits > 0 || k === queryKind && queryKind !== 'other') relevant = true;
      }
      for (const a of active) {
        const ak = kind(a.p);
        const modelMatch = models(p).some(m => models(a.p).includes(m));
        const related = (p.groups || []).some(g => !broad.test(g) && (a.p.groups || []).includes(g));
        const overlap = words(a.p.title).filter(t => pTerms.includes(t)).length;
        const complementary = (complements[ak] || []).includes(k);
        score += a.weight * ((modelMatch ? 5 : 0) + (related ? 2 : 0) + (ak === k && k !== 'other' ? 1 : 0) + (complementary && (modelMatch || related || ['charger', 'powerbank', 'cable', 'audio', 'stand'].includes(k)) ? 1.4 : 0) + Math.min(3, overlap) * .3);
        if (modelMatch || related || overlap >= 2) relevant = true;
        if (String(a.p.id) === String(p.id)) score -= 4;
      }
      if (k === 'sticker' && !relevant) score -= 25;
      if (k === 'digital' && !relevant) score -= 35;
      const entry = {p, score, k, family: family(p), relevant, index};
      if (!unique.has(String(p.id)) || unique.get(String(p.id)).score < score) unique.set(String(p.id), entry);
    });
    const sorted = [...unique.values()].sort((a, b) => b.score - a.score || a.index - b.index);
    const selected = [], families = new Set(), kinds = new Map(), brands = new Map();
    let cheap = 0;
    for (const item of sorted) {
      if (selected.length >= limit) break;
      if (families.has(item.family)) continue;
      const maximumKind = item.relevant ? 14 : 8;
      if ((kinds.get(item.k) || 0) >= maximumKind || (brands.get(item.p.vendor) || 0) >= 12) continue;
      if (Number(item.p.price) <= 5000 && cheap >= 4 && !item.relevant) continue;
      selected.push(item.p);
      families.add(item.family);
      kinds.set(item.k, (kinds.get(item.k) || 0) + 1);
      brands.set(item.p.vendor, (brands.get(item.p.vendor) || 0) + 1);
      if (Number(item.p.price) <= 5000) cheap++;
    }
    return selected;
  }
  function sourceQueries(profile) {
    const now = Date.now();
    const active = anchors(profile || {}, now).sort((a, b) => b.weight - a.weight);
    const result = [];
    if (profile.query?.value && now - profile.query.at < DAY) result.push({type: 'search', value: profile.query.value.slice(0, 100)});
    const seed = active[0]?.p;
    if (seed) {
      const model = models(seed)[0];
      if (model) result.push({type: 'search', value: model});
      const group = (seed.groups || []).find(g => !broad.test(g) && /^[a-z0-9-]{1,100}$/.test(g));
      if (group) result.push({type: 'collection', value: group});
      else if (!model && words(seed.title).length) result.push({type: 'search', value: words(seed.title).slice(0, 3).join(' ')});
    }
    const seen = new Set();
    return result.filter(s => {const key = s.type + ':' + s.value;if(seen.has(key))return false;seen.add(key);return true;}).slice(0, 3);
  }
  root.TamimiPicksEngine = Object.freeze({version: '1.0.0', norm, kind, models, whoop, family, compatible, rank, sourceQueries});
  if (typeof module !== 'undefined' && module.exports) module.exports = root.TamimiPicksEngine;
})(typeof window === 'undefined' ? globalThis : window);
